import React from 'react';
import PropTypes from 'prop-types';

import { IClassNames, makeClassNames } from '../../../utils/styles';
import './error.scss';
import t from '../../../labels/labelling-utils';

export interface IError {
  children?: React.ReactNode | React.ReactNode[];
}
const defaultError = t('unavailable.data');

const classNames = (): IClassNames =>
  makeClassNames({
    error: 'error',
  });

const Error: React.FC<IError> = ({ children = defaultError }) => {
  const cn = classNames();

  return <div className={cn.error}>{children}</div>;
};

Error.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default Error;
